import React from 'react';

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { ArrowLink } from 'components/arrow-link';
import useDialogModal from 'hooks/use-dialog-modal';
import useRoutes from 'hooks/use-routes';
import { CustomEventNames, useMParticleContext } from 'state/mParticle';
import { getConfigValue } from 'utils/environment';
import { routes } from 'utils/routing';

import { isTimsTermsCondition } from './fzConfig';

const LinkContainer = styled.div`
  margin-top: 1rem;
`;

export const TermsSection = () => {
  const { deleteAccountUrl } = getConfigValue('oneTrust');

  const { formatMessage } = useIntl();
  const { getLocalizedRouteForPath, doesPageExist } = useRoutes();
  const mParticle = useMParticleContext();

  const navigate = useNavigate();

  const [Confirm, openConfirm] = useDialogModal<{ id: string }>({
    onConfirm: () => {
      mParticle.logNavigationClick(CustomEventNames.BUTTON_CLICK_SIGN_OUT);
      navigate(routes.signOut);
    },
    showCancel: true,
    modalAppearanceEventMessage: 'Confirmation: Sign Out',
  });

  const showSignOutConfirm = (e: React.MouseEvent) => {
    e.preventDefault();
    openConfirm();
  };

  const doesTermOfServicePageExist = doesPageExist('terms-of-service');

  return (
    <LinkContainer>
      <ArrowLink
        to={getLocalizedRouteForPath('privacy-policy')}
        eventName={CustomEventNames.BUTTON_CLICK_PRIVACY_POLICY}
      >
        {formatMessage({ id: 'privacyPolicy' })}
      </ArrowLink>
      {doesTermOfServicePageExist && (
        <ArrowLink to={getLocalizedRouteForPath('terms-of-service')}>
          {formatMessage({ id: 'termsOfService' })}
        </ArrowLink>
      )}
      {isTimsTermsCondition && (
        <ArrowLink to={getLocalizedRouteForPath('terms-conditions-rewards')}>
          {formatMessage({ id: 'timsRewardsTermsAndConditions' })}
        </ArrowLink>
      )}
      <ArrowLink to={routes.signOut} onClick={showSignOutConfirm} data-testid="signout-button">
        {formatMessage({ id: 'signOut' })}
      </ArrowLink>
      {deleteAccountUrl && (
        <ArrowLink
          to={deleteAccountUrl}
          eventName={CustomEventNames.BUTTON_CLICK_ACCOUNT_DELETE_ONE_TRUST}
        >
          {formatMessage({ id: 'manageMyData' })}
        </ArrowLink>
      )}
      <Confirm
        heading={formatMessage({ id: 'signOut' })}
        body={formatMessage({ id: 'signOutConfirmSubheader' })}
        confirmLabel={formatMessage({ id: 'yes' })}
        cancelLabel={formatMessage({ id: 'no' })}
      />
    </LinkContainer>
  );
};
